export default __webpack_public_path__ + "static/media/panna-resume-score.ed1b47c3.png";